import { TimerTypes } from '../constants/timerConstants';

const toggleTimer = () => ({
    type: TimerTypes.TOGGLE_TIMER
});

const markTimerChanged = (state) => ({
    type: TimerTypes.TOGGLE_TIMER,
    state,
});

const updateTimers = (data) => ({
    type: TimerTypes.UPDATE_TIMERS,
    ...data
});

export default {
    toggleTimer,
    updateTimers,
    markTimerChanged
};